export interface CidadeCertificado {
  slug: string;
  nome: string;
  uf: string;
  estado: string;
}

export const CIDADES_CERTIFICADO: CidadeCertificado[] = [
  // Capitais
  { slug: "aracaju", nome: "Aracaju", uf: "SE", estado: "Sergipe" },
  { slug: "belem", nome: "Belém", uf: "PA", estado: "Pará" },
  { slug: "belo-horizonte", nome: "Belo Horizonte", uf: "MG", estado: "Minas Gerais" },
  { slug: "boa-vista", nome: "Boa Vista", uf: "RR", estado: "Roraima" },
  { slug: "brasilia", nome: "Brasília", uf: "DF", estado: "Distrito Federal" },
  { slug: "campo-grande", nome: "Campo Grande", uf: "MS", estado: "Mato Grosso do Sul" },
  { slug: "cuiaba", nome: "Cuiabá", uf: "MT", estado: "Mato Grosso" },
  { slug: "curitiba", nome: "Curitiba", uf: "PR", estado: "Paraná" },
  { slug: "florianopolis", nome: "Florianópolis", uf: "SC", estado: "Santa Catarina" },
  { slug: "fortaleza", nome: "Fortaleza", uf: "CE", estado: "Ceará" },
  { slug: "goiania", nome: "Goiânia", uf: "GO", estado: "Goiás" },
  { slug: "joao-pessoa", nome: "João Pessoa", uf: "PB", estado: "Paraíba" },
  { slug: "macapa", nome: "Macapá", uf: "AP", estado: "Amapá" },
  { slug: "maceio", nome: "Maceió", uf: "AL", estado: "Alagoas" },
  { slug: "manaus", nome: "Manaus", uf: "AM", estado: "Amazonas" },
  { slug: "natal", nome: "Natal", uf: "RN", estado: "Rio Grande do Norte" },
  { slug: "palmas", nome: "Palmas", uf: "TO", estado: "Tocantins" },
  { slug: "porto-alegre", nome: "Porto Alegre", uf: "RS", estado: "Rio Grande do Sul" },
  { slug: "porto-velho", nome: "Porto Velho", uf: "RO", estado: "Rondônia" },
  { slug: "recife", nome: "Recife", uf: "PE", estado: "Pernambuco" },
  { slug: "rio-branco", nome: "Rio Branco", uf: "AC", estado: "Acre" },
  { slug: "rio-de-janeiro", nome: "Rio de Janeiro", uf: "RJ", estado: "Rio de Janeiro" },
  { slug: "salvador", nome: "Salvador", uf: "BA", estado: "Bahia" },
  { slug: "sao-luis", nome: "São Luís", uf: "MA", estado: "Maranhão" },
  { slug: "sao-paulo", nome: "São Paulo", uf: "SP", estado: "São Paulo" },
  { slug: "teresina", nome: "Teresina", uf: "PI", estado: "Piauí" },
  { slug: "vitoria", nome: "Vitória", uf: "ES", estado: "Espírito Santo" },
  // Cidades extras estratégicas
  { slug: "caruaru", nome: "Caruaru", uf: "PE", estado: "Pernambuco" },
  { slug: "garanhuns", nome: "Garanhuns", uf: "PE", estado: "Pernambuco" },
  { slug: "arapiraca", nome: "Arapiraca", uf: "AL", estado: "Alagoas" },
  { slug: "campina-grande", nome: "Campina Grande", uf: "PB", estado: "Paraíba" },
  { slug: "feira-de-santana", nome: "Feira de Santana", uf: "BA", estado: "Bahia" },
  { slug: "petrolina", nome: "Petrolina", uf: "PE", estado: "Pernambuco" },
  { slug: "vitoria-da-conquista", nome: "Vitória da Conquista", uf: "BA", estado: "Bahia" },
  { slug: "juazeiro", nome: "Juazeiro", uf: "BA", estado: "Bahia" },
  // Cidades estratégicas de Alagoas (foco local)
  { slug: "penedo", nome: "Penedo", uf: "AL", estado: "Alagoas" },
  { slug: "uniao-dos-palmares", nome: "União dos Palmares", uf: "AL", estado: "Alagoas" },
  { slug: "rio-largo", nome: "Rio Largo", uf: "AL", estado: "Alagoas" },
  { slug: "palmeira-dos-indios", nome: "Palmeira dos Índios", uf: "AL", estado: "Alagoas" },
  { slug: "coruripe", nome: "Coruripe", uf: "AL", estado: "Alagoas" },
  { slug: "delmiro-gouveia", nome: "Delmiro Gouveia", uf: "AL", estado: "Alagoas" },
  { slug: "sao-miguel-dos-campos", nome: "São Miguel dos Campos", uf: "AL", estado: "Alagoas" },
  { slug: "marechal-deodoro", nome: "Marechal Deodoro", uf: "AL", estado: "Alagoas" },
];

export const getCidadeBySlug = (slug: string): CidadeCertificado | undefined =>
  CIDADES_CERTIFICADO.find((c) => c.slug === slug);
